import axios from 'axios'
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth'
import {globalConfig} from '@/utils/config'
import HttpStatus from '@/utils/httpStatus'
import Cookies from 'js-cookie'


let loading;

function startLoading() {
    // loading = Loading.service({
    //     lock: true,
    //     customClass: 'loading-container',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    // })
}
function endLoading() {
    // loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function hideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) {
        return
    }
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}
// 设置全局请求头
axios.defaults.headers.common['X-Requested-With'] = 'AJAX';
// 开发环境 设置API Server && Request Token
// if(process.env.NODE_ENV === 'development') {
//     axios.defaults.baseURL = globalConfig.VUE_APP_BASE_API;
//     axios.defaults.headers.common["Authorization"] = "Bearer 34d5f6c6f1eee10f8035a56b6356df90";
// }

// create an axios instance
const service = axios.create()

// request interceptor
service.interceptors.request.use(
    config => {
        if (!config.headers.unLoading) {
            showFullScreenLoading();
        }
        return config;
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        hideFullScreenLoading();
        const res = response.data;
        if (typeof (res) === 'string') {
            //返回内容不是JSON
            let responseURL = response.request.responseURL;
            if (!responseURL.includes(response.config.url)) {
                reLogin();
            } else {
                return Promise.reject(new Error(res || 'Error'))
            }
        } else {
            // if the custom code is not 200, it is judged as an error.
            if (res.status && res.status !== HttpStatus.OK) {
                Message({
                    message: res.message || '请求错误',
                    type: 'error',
                    duration: 5 * 1000
                })

                if (res.status == HttpStatus.INVALID_TOKEN) {
                    // to re-login
                    reLogin();
                }
                return Promise.reject(new Error(res || 'Error'))
            } else {
                //将服务器时间存入cookie
                let date = new Date(response.headers['date']).toLocaleString('zh-CN', {hour12: false})
                Cookies.set("sysTime", date);
                return res
            }
        }
    },
    async error => {
        hideFullScreenLoading()
        if (error.response.status === HttpStatus.INVALID_TOKEN) {
            reLogin();
        } else if (error.response.status === HttpStatus.FORBIDDEN) {
            Message({
                message: error.response.data.message,
                type: 'error',
                duration: 5 * 1000
            })
        } else {
            let errMessage;
            if (error.message.includes('timeout')) {
                errMessage = '请求超时';
            } else {
                try {
                    errMessage = error.response.data.message;
                } catch (err) {
                    errMessage = '请求错误';
                }
            }
            Message({
                message: errMessage,
                type: 'error',
                duration: 5 * 1000
            })

            return Promise.reject(error)
        }
    }
)

/**
 * 模拟休眠
 * @param time 毫秒
 * @returns {Promise}
 */
function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
}

/**
 * 重新登录
 */
function reLogin() {
    Message({
        message: '当前会话已超时，请重新登录！',
        type: 'error',
        duration: 1 * 1000
    })
    sleep(1500).then(() => {
        location.reload()
    })
}

export default service
